// Server-fn middleware that gates every mutating server function on the
// caller having a confirmed email address. Chains requireSupabaseAuth so
// callers only add this one middleware to protect a write endpoint.
//
// Confirmation source of truth: `auth.users.email_confirmed_at`, read
// server-side via the admin API using the verified `sub` claim from
// requireSupabaseAuth. We do NOT trust `user_metadata.email_verified`
// (user-editable) or any client-supplied field. The Supabase JWT itself
// does not carry `email_confirmed_at`, so a per-call admin lookup is the
// only reliable path.
import { createMiddleware } from "@tanstack/react-start";
import { requireSupabaseAuth } from "./auth-middleware";

export const EMAIL_NOT_CONFIRMED_CODE = "email_not_confirmed";
export const EMAIL_NOT_CONFIRMED_MESSAGE =
  "Confirm your email address to continue. We sent a link when you signed up.";

export const requireEmailConfirmed = createMiddleware({ type: "function" })
  .middleware([requireSupabaseAuth])
  .server(async ({ next, context }) => {
    const { supabaseAdmin } = await import("./client.server");
    const { data, error } = await supabaseAdmin.auth.admin.getUserById(
      context.userId,
    );
    if (error || !data?.user || !data.user.email_confirmed_at) {
      throw new Response(
        JSON.stringify({
          code: EMAIL_NOT_CONFIRMED_CODE,
          message: EMAIL_NOT_CONFIRMED_MESSAGE,
        }),
        {
          status: 403,
          headers: { "content-type": "application/json" },
        },
      );
    }
    return next();
  });